var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgIe = function SvgIe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h639.995v480.004H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009A49",
    d: "M0 0h213.334v480.004H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7900",
    d: "M426.668 0h213.334v480.004H426.668z"
  }))));
};
export default __webpack_public_path__ + "assets/6a6841f17bbdd148b6bfce78d4e76b41.svg";
export { SvgIe as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/ie.svg